module.exports = __webpack_public_path__ + "static/media/M.de933361.png";